'use client'
import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import ServiceBox from "@/components/service/ServiceBox";
import {marengo, white} from "@/styles/globalStyleVars";
import Title from "@/components/Title";
import parser from "html-react-parser";

const MyComponent = ({data}) => {

    return (
        <StyledComponent  className={'pt-120 pb-120'}>
            <Container>
                <Title text={data?.title} color={`${white}`}/>
                <h3 className={'split-up'}>{parser(data?.description)}</h3>
                <Row>
                    {
                        data?.list && data?.list?.length > 0 &&
                        data?.list?.map((e,index) => {
                            return(
                                <Col md={4} key={index}>
                                    <ServiceBox
                                        title={e?.title}
                                        desc={e?.icon}
                                    />
                                </Col>
                            )
                        })
                    }


                </Row>
            </Container>

        </StyledComponent>
    );
};
const StyledComponent = styled.section`
  background: ${marengo};
  position: relative;
  height: 100%; /* Ensure the component takes up the full height of its container */
  display: flex;
  justify-content: center; /* Horizontally center the content */
  align-items: center; /* Vertically center the content */
  
  .col-md-4{
    margin-bottom: 30px;
  }
  h3{
    color: ${white};
    margin-bottom: 60px;
  }
  
`
export default MyComponent;